export const HTTP_METHODS = [
  {label: "POST", value: "POST"},
  {label: "GET", value: "GET"},
  {label: "PUT", value: "PUT"},
  {label: "PATCH", value: "PATCH"},
  {label: "DELETE", value: "DELETE"},
];

export const DEFAULT_FORM_DATA = {
  additional_headers: [],
  http_method: "POST",
  name: "",
  secret: "",
  ssl_verification: false,
  url: "",
};
